import styles from './loginSignup.module.css';
import Popup from '../components/popup/popup.jsx';
import { memo, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../components/button/button.jsx';
import success from '../icons/success.svg'
import ChangePassword from './Components/ChangePassword.jsx';
import Reset from './Components/Reset.jsx';
import Signup from './Components/Signup.jsx';
import Login from './Components/Login.jsx';

const LoginSignup = () => {
  const [infoPopup, setinfoPopup] = useState({ show: false, message: "" });
  const [mode, setMode] = useState('login');
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const action = searchParams.get("action");
    setMode(action || 'login')
  }, [searchParams])

  const setModeFunc = (mode) => {
    setMode(mode)
    setSearchParams({ action: mode })
  }

  const handleClose = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  }

  return (
    <div className={styles.backImage}>
      <Popup visible={infoPopup.show} id={styles.message}>
        {!infoPopup.message.includes('Error') && <img src={success} alt="success" style={{ width: '40px', height: "40px" }} />}
        <p style={{ textAlign: 'center', fontSize: '18px', marginTop: "20px" }}> {infoPopup.message}</p>
        <Button
          onClick={() => navigate('/')}
          style={{ marginTop: "40px", maxWidth: "350px" }}
          children={!infoPopup.message.includes('Error') ? 'Continue' : 'OK'}
        />
      </Popup>

      <Popup visible={!infoPopup.show} id={mode === 'reset' ? styles.resetMode : null} closeBtn onClose={handleClose}>
        {
          mode === 'login' ? <Login frogotFunc={() => setModeFunc('reset')} signUpFunc={() => setModeFunc('signup')} />
            : mode === 'signup' ? <Signup setinfoPopup={setinfoPopup} setMode={() => setModeFunc('login')} />
              : mode === 'reset' ? <Reset signUpFunc={() => setModeFunc('signup')} setinfoPopup={setinfoPopup} />
                : mode === 'verify' && <ChangePassword setinfoPopup={setinfoPopup} />
        }
      </Popup>
    </div>
  );
};
export default memo(LoginSignup);